import React from 'react'
import "./Button.css"

const Button = ({ text, black }) => {
    return (
        <div className={`${black && "black"} button`}>{text}</div>
    )
}

export default Button